import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Table } from "primeng/table"; 
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { CatDireccionesService } from "../../servicios/cat-direcciones.service";
import { CatDepartamentosService } from "../../servicios/cat-departamentos.service";
import { CatCargosService } from "../../servicios/cat-cargos.service";
import { CatSucursalesService } from "../../servicios/cat-sucursales.service";
import { EnviarCorreoService } from "app/servicios/enviar-correo.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatUsuarios } from "../../entidades/entidades";
import { EnviarCorreo } from "../../entidades/entidades";

@Component({
    selector: "app-cat-usuarios-grid",
    templateUrl: "./cat-usuarios-grid.component.html",
    styleUrls: ["./cat-usuarios-grid.component.css"],
})
export class CatUsuariosGridComponent implements OnInit {
    muestraMensaje = new MuestraMensaje();
    catEstatus: SelectItem[];
    catDirecciones: SelectItem[];
    catDepartamentos: SelectItem[];
    catCargos: SelectItem[];
    catSucursales: SelectItem[];
    catUsuarios: any[] = [];
    itemsMenu: MenuItem[];
    columnasTabla: any[];
    clonedCatUsuarios: { [s: string]: CatUsuarios } = {};
    public visible: boolean = false;
    progressBar: boolean = false;
    fechaActual: Date;
    public getAreasGlobal: any[];
    @ViewChild('dtcatUsuarios') tabla: Table;

    constructor(
        private catUsuariosService: CatUsuariosService,
        private catEstatusService: CatEstatusService,
        private catDireccionesService: CatDireccionesService,
        private catDepartamentosService: CatDepartamentosService,
        private catCargosService: CatCargosService,
        private catSucursalesService: CatSucursalesService,
        private enviarCorreoService: EnviarCorreoService,
    ) { }

        @ViewChild('dtcatUsuarios') dtcatUsuarios: Table;
        @ViewChild('filterInputNombre') filterInputNombre: ElementRef;
        @ViewChild('filterInputNombreU') filterInputNombreU: ElementRef;
        @ViewChild('filterInput1Apellido') filterInput1Apellido: ElementRef;
        @ViewChild('filterInput2Apellido') filterInput2Apellido: ElementRef;
        @ViewChild('filterInputTelfono') filterInputTelfono: ElementRef;
        @ViewChild('filterInputCorreo') filterInputCorreo: ElementRef;
        @ViewChild('filterInputAlta') filterInputAlta: ElementRef;

    async ngOnInit() {
        await this.getAllCatEstatus();
        await this.getAllCatDirecciones();
        await this.getAllCatDepartamentos();
        await this.getAllCatCargos();
        await this.getAllCatSucursales();
        // this.getAllCatUsuarios();

        // ===============================================================
        //Opciones del menu
        // ===============================================================
        // prettier-ignore
        this.itemsMenu = [
            { label: "Agregar", icon: "pi pi-file-o", command: () => this.add(), },
            { label: "Todo", icon: "pi pi-eye", command: (event) => { this.getAllCatUsuarios(); } },
            { label: "Buscar", icon: "pi pi-search", command: (event) => { this.getAllCatUsuarios(); } },
            { label: "Guardar", icon: "pi pi-save", command: (event) => { this.guardarGridCatUsuarios(); } },
            { label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.getAllCatUsuarios(); } },
            { label: "Limpiar", icon: "pi pi-undo", command: (event) => { this.limpiar(); } },
        ];

        // ===============================================================
        //Opciones de la tabla
        // ===============================================================
        // prettier-ignore
        this.columnasTabla = [
          {field: "operacion", header: "Editar", ordenar: false, styleHeader: "width: 70px;", },
          {field: "unlock", header: "Bloqueo", ordenar: false, styleHeader: "width: 80px;", },
          {field: "nombreUsuario", header: "Nombre Usuario",ordenar: true, styleHeader: "width: 300px;", },
          {field: "cuadrilla", header: "Cuadrilla",ordenar: true, styleHeader: "width: 300px;", },
          {field: "nombre", header: "Nombre",ordenar: true, styleHeader: "width: 150px;",},
          {field: "primerApellido", header: "Primer Apellido",ordenar: true, styleHeader: "width: 150px;",},
          {field: "segundoApellido", header: "Segundo Apellido",ordenar: true, styleHeader: "width: 150px;",},
          {field: "telefono", header: "Telefono",ordenar: true, styleHeader: "width: 150px;",},
          {field: "correoElectronico", header: "Correo Electronico",ordenar: true, styleHeader: "width: 300px;",},
          
        //   
          {field: "idEstatus", header: "Estatus",ordenar: true, styleHeader: "width: 250px;",},
          {field: "idDireccion", header: "Dirección",ordenar: true, styleHeader: "width: 250px;",},
          {field: "idDepartamento", header: "Departamento",ordenar: true, styleHeader: "width: 250px;",},
          {field: "idCargo", header: "Cargo",ordenar: true, styleHeader: "width: 250px;",},
        //   {field: "token", header: "Token",ordenar: true, styleHeader: "width: 150px;"},
          {field: "idSucursal", header: "Sucursal",ordenar: true, styleHeader: "width: 250px;",},
        //   {field: "sesionActiva", header: "Sesion Activa",ordenar: true, styleHeader: "width: 150px;",},
        //  {field: "fechaApertura", header: "Fecha Apertura",ordenar: true, styleHeader: "width: 150px;",},
          {field: "fechaAlta", header: "Fecha Alta",ordenar: true, styleHeader: "width: 150px;",},
          {field: "fechaBaja", header: "Fecha Baja",ordenar: true, styleHeader: "width: 100px;",},
        //   {field: "info", header: "Info",ordenar: true, styleHeader: "width: 150px;",},
          {field: "fechaCambio", header: "Fecha Cambio Contrasenia",ordenar: true, styleHeader: "width: 150px;",},
          {field: "contrasenia", header: "Contraseña",ordenar: true, styleHeader: "width: 150px;",},
          {field: "sesionActiva", header: "Sesión Activa",ordenar: true, styleHeader: "width: 150px;",},
          //{field: "acciones", header: "Eliminar",ordenar: false, styleHeader: "width: 70px;",},
  
        ];

    }
    //===============================================================
    //Agrega renglon en el grid
    //===============================================================
    // prettier-ignore
    add() {
        
        let catUsuariosNew = new CatUsuarios();
        catUsuariosNew.cambio = true;
        catUsuariosNew.id = 0;
        if(this.catUsuarios!=undefined)
           catUsuariosNew.numRow = this.catUsuarios.length + 1;
        else 
           catUsuariosNew.numRow =1;

        catUsuariosNew.fechaAlta=new Date();
        catUsuariosNew.fechaApertura=new Date();
        catUsuariosNew.fechaCambioContrasenia=new Date();
        catUsuariosNew.idEstatus=1;
        catUsuariosNew.idDireccion=1;
        catUsuariosNew.idDepartamento=2;
        catUsuariosNew.idCargo=1;
        catUsuariosNew.idSucursal=1;
        var result = new Date(new Date());
        result.setDate(result.getDate() + 30);
        catUsuariosNew.fechaBaja=result;
      
       if(this.catUsuarios!=undefined)
          this.catUsuarios.unshift(catUsuariosNew);
         else   
            this.catUsuarios = [catUsuariosNew];
    }

    //===============================================================
    //Funciones de la tabla
    //===============================================================
    // prettier-ignore
    onEditInit(event) {
      
        let catUsuariosEdit = event.data;
        this.clonedCatUsuarios[catUsuariosEdit.numRow] = { ...catUsuariosEdit };
        catUsuariosEdit.cambio = true;
        catUsuariosEdit.baja = false;
    }

    // prettier-ignore
       async onEditCancel(event) {
            let catUsuariosEdit = event.data;
            let index = this.catUsuarios.findIndex(
              (obj) => obj.id === catUsuariosEdit.id
            );
            this.catUsuarios[index] = { ...this.clonedCatUsuarios[catUsuariosEdit.id]};
            
          await this.getAllCatUsuarios();
            
    }

    // prettier-ignore
    onDelete(event, index: number) {
        event.cambio = false;
        event.baja = true;
    }

    onUnlock(event, index: number){
          event.cambio = true;
          event.sesionActiva=null;
          event.fechaApertura=null;
          event.token="fghj";
          event.idEstatus=1;
        
    }
    // prettier-ignore
    async onEditComplete(event) {
        try { 
            let catUsuariosEdit = event.data; 
            //Valida si hay cambios
            if (
                // catUsuariosEdit.id === this.clonedCatUsuarios[catUsuariosEdit.numRow].id &&
                catUsuariosEdit.nombreUsuario === this.clonedCatUsuarios[catUsuariosEdit.numRow].nombreUsuario &&
                catUsuariosEdit.nombre === this.clonedCatUsuarios[catUsuariosEdit.numRow].nombre &&
                catUsuariosEdit.primerApellido === this.clonedCatUsuarios[catUsuariosEdit.numRow].primerApellido &&
                catUsuariosEdit.segundoApellido === this.clonedCatUsuarios[catUsuariosEdit.numRow].segundoApellido &&
                catUsuariosEdit.telefono === this.clonedCatUsuarios[catUsuariosEdit.numRow].telefono &&
                catUsuariosEdit.correoElectronico === this.clonedCatUsuarios[catUsuariosEdit.numRow].correoElectronico &&
                // catUsuariosEdit.fechaAlta === this.clonedCatUsuarios[catUsuariosEdit.numRow].fechaAlta &&
                catUsuariosEdit.fechaBaja === this.clonedCatUsuarios[catUsuariosEdit.numRow].fechaBaja &&
                catUsuariosEdit.idEstatus === this.clonedCatUsuarios[catUsuariosEdit.numRow].idEstatus &&
                catUsuariosEdit.contrasenia === this.clonedCatUsuarios[catUsuariosEdit.numRow].contrasenia &&
                catUsuariosEdit.idDireccion === this.clonedCatUsuarios[catUsuariosEdit.numRow].idDireccion &&
                catUsuariosEdit.idDepartamento === this.clonedCatUsuarios[catUsuariosEdit.numRow].idDepartamento &&
                catUsuariosEdit.idCargo === this.clonedCatUsuarios[catUsuariosEdit.numRow].idCargo &&
                // catUsuariosEdit.token === this.clonedCatUsuarios[catUsuariosEdit.numRow].token &&
                catUsuariosEdit.idSucursal === this.clonedCatUsuarios[catUsuariosEdit.numRow].idSucursal &&
                catUsuariosEdit.sesionActiva === this.clonedCatUsuarios[catUsuariosEdit.numRow].sesionActiva &&
                // catUsuariosEdit.fechaApertura === this.clonedCatUsuarios[catUsuariosEdit.numRow].fechaApertura &&
                // catUsuariosEdit.info === this.clonedCatUsuarios[catUsuariosEdit.numRow].info &&
                catUsuariosEdit.fechaCambioContrasenia === this.clonedCatUsuarios[catUsuariosEdit.numRow].fechaCambioContrasenia &&
                catUsuariosEdit.idDireccionDepartamento === this.clonedCatUsuarios[catUsuariosEdit.numRow].idDireccionDepartamento && 
                catUsuariosEdit.cuadrilla === this.clonedCatUsuarios[catUsuariosEdit.numRow].cuadrilla
              ) {
              
                let index = this.catUsuarios.findIndex((obj) => obj.numRow === catUsuariosEdit.numRow);
                this.catUsuarios[index] = {...this.clonedCatUsuarios[catUsuariosEdit.numRow]};
                return;
              }

            //Validaciones
            //throw new Error("No paso las validaciones.");

            catUsuariosEdit.cambio = true;
            catUsuariosEdit.baja = false; 
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por onEditComplete");
        }
    }
    //===============================================================
    //Interaccion con servicios
    //===============================================================
    // prettier-ignore
    async guardarGridCatUsuarios() {
        try { 
            this.progressBar = true; 
          var auxFiltrado = this.catUsuarios.filter(x => x.baja || x.cambio); 
          for (let catUsuariosFor of auxFiltrado) { 
            if (catUsuariosFor.baja) {
              await this.deleteCatUsuarios(catUsuariosFor);
            } else if (catUsuariosFor.cambio) {  
              if (catUsuariosFor.id === 0) {
                const datoRetorno = await this.addCatUsuarios(catUsuariosFor);
                catUsuariosFor.id = datoRetorno.id;
              } else { 
                await this.updateCatUsuarios(catUsuariosFor);
              } 
            }
            catUsuariosFor.cambio = false;
          }
    
          this.muestraMensaje.notification("Proceso Concluido.", "top", "center");

          await this.getAllCatUsuarios();
        } catch (e) {
          this.muestraMensaje.error(e.message, "top", "center");
        } finally {
          console.log("Paso por guardarCatUsuarios");
          this.progressBar = false;
        }
      }

    // prettier-ignore
    async addCatUsuarios(catUsuarios) {
        try {
            let msjError = "";

            if(catUsuarios.nombreUsuario==undefined || catUsuarios.nombreUsuario==null || catUsuarios.nombreUsuario=="")
               msjError+=  "El nombre de usuario es requerido. \n";
            if(catUsuarios.nombre==undefined || catUsuarios.nombre==null || catUsuarios.nombre=="")
                msjError+=  "El nombre es requerido. \n";
            if(catUsuarios.primerApellido==undefined || catUsuarios.primerApellido==null || catUsuarios.primerApellido=="")
                msjError+=  "El primer apellido es requerido. \n";
            if(catUsuarios.segundoApellido==undefined || catUsuarios.segundoApellido==null || catUsuarios.segundoApellido=="")
                msjError+=  "El segundo apellido es requerido. \n";
            if(catUsuarios.correoElectronico==undefined || catUsuarios.correoElectronico==null || catUsuarios.correoElectronico=="")    
                msjError+=  "El correo electronico es requerido. \n";
             else if(!this.isValidEmail(catUsuarios.correoElectronico))
                msjError+=  "El correo electronico, no tiene el formato correcto. \n";
             if(catUsuarios.nombre==undefined || catUsuarios.nombre==null || catUsuarios.nombre=="")    
                msjError+=  "El nombre es requerido. \n";
            if(catUsuarios.idSucursal==undefined || catUsuarios.idSucursal==null || catUsuarios.idSucursal==0) 
                msjError+=  "La sucursal es requerida. \n";
             if(catUsuarios.idDireccion==undefined || catUsuarios.idDireccion==null || catUsuarios.idDireccion==0)
                msjError+=  "La direccion es requerida. \n";
            if(catUsuarios.idDepartamento==undefined || catUsuarios.idDepartamento==null || catUsuarios.idDepartamento==0)
                msjError+=  "El departamento es requerido. \n";
            if(catUsuarios.idCargo==undefined || catUsuarios.idCargo==null || catUsuarios.idCargo==0)
                msjError+=  "El cargo es requerido. \n";
            if(catUsuarios.contrasenia==undefined || catUsuarios.contrasenia==null || catUsuarios.contrasenia=="")
                msjError+=  "La contraseña es requerida. \n";


               
           if(msjError!="")
             throw new Error(msjError);
            
            //agregamos la info de departamento en el json
            var auxJson = JSON.stringify({
                direccionDepartamentoDescripcion:    catUsuarios.direccionDepartamentoDescripcion,
                idDireccionDepartamento:             catUsuarios.idDireccionDepartamento
            });
            catUsuarios.datosadicionales = auxJson;

            const datoretorno = await this.catUsuariosService
                .add(catUsuarios)
                .toPromise();

            const correo = datoretorno.correoElectronico;
            await this.enviarContrasenia(correo, catUsuarios.contrasenia)
            return datoretorno;
        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por addCatUsuarios");
        }
    }

    async enviarContrasenia(correo: string, catUsuarios: string){
        
        try{
            const enviarCorreo: EnviarCorreo = {
                idFactura: null,
                correo: correo,
                correocopia: null,
                enviosFactura: null,
                contrasenia: catUsuarios
            }
            
            await this.enviarCorreoService.add(enviarCorreo).toPromise();
        }catch (e){
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        }finally{
            console.log("Paso por enviaContraseña");
        }
    }

    async onDireccioDepartamentonSelec(renglon: any, event: any, flag){
        try {

           let selectedOption: any = {};
           selectedOption = this.getAreasGlobal.find(opcion => opcion.id === event?.value);
           renglon.direccionDepartamentoDescripcion = selectedOption?.descripcion;
           renglon.idDireccionDepartamento = selectedOption?.id; 

           var datosAdicionalesJson = JSON.stringify({
            idDireccionDepartamento:            selectedOption?.descripcion,
            direccionDepartamentoDescripcion:   selectedOption?.id
          });

          renglon.datosadicionales = datosAdicionalesJson;
           

         } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center"); 
           
         } finally {
           console.log('Paso por onDireccioDepartamentonSelec');
         }
       }

    async onDireccionSelec(renglon: any, event: any){
        try {
            
           let selectedOption: any = {};
           selectedOption = this.catDirecciones.find(opcion => opcion.value === event.value);
           renglon.idDireccion = selectedOption.value;

           renglon.catDireccionesDepartamentos = this.getAreasGlobal.filter((opcion) => opcion.idPadre === selectedOption.value) 
           .map((datos)=> {return {label:datos.descripcion, value:datos.id  , title: datos.idPadre?.toString()}})
 
           await this.onDireccioDepartamentonSelec(renglon, renglon.catDireccionesDepartamentos?.[0] || null, true);

            
         } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center"); 
           
         } finally {
           console.log('Paso por onDireccionSelec');
         }
       }

    // prettier-ignore
    async getAllCatUsuarios() {
        try {
            
            this.catUsuarios = [];
            const datoRetorno = await this.catUsuariosService.getAllInfo().toPromise();

            this.catUsuarios =  datoRetorno;

            for (var i = 0, len = this.catUsuarios.length; i < len; ++i){
                
                if (this.catUsuarios[i].idEstatus === 4) {
                    this.visible = true;
                }

                this.catUsuarios[i].cambio = false;
                this.catUsuarios[i].baja = false;

                this.catUsuarios[i].numRow=i;
                this.clonedCatUsuarios[this.catUsuarios[i].id] = { ...this.catUsuarios[i], };


                let selectedOption: any = {};
                selectedOption.value = this.catUsuarios[i].idDireccion;
                
                this.catUsuarios[i].catDireccionesDepartamentos = this.getAreasGlobal.filter((opcion) => opcion.idPadre === selectedOption.value) 
                .map((datos)=> {return {label:datos.descripcion, value:datos.id  , title: datos.idPadre?.toString()}})
                this.catUsuarios[i].catDireccionesDepartamentos.unshift({ label: 'SELECCIONA...', value: null });

                //console.log('checamos que depa tiene',this.catUsuarios[i].info )

                // Parsear el texto JSON a un objeto
                const jsonObject = JSON.parse(this.catUsuarios[i].datosadicionales);

              
                // Verificar si la clave existe en el objeto
                if (jsonObject != null ) {
                    if ("idDireccionDepartamento" in jsonObject) this.catUsuarios[i].idDireccionDepartamento = jsonObject.idDireccionDepartamento; 

                    var aux  = this.getAreasGlobal.find((opcion) => opcion.id === this.catUsuarios[i]?.idDireccionDepartamento) ;
                    this.catUsuarios[i].catDireccionesDepartamentos = this.getAreasGlobal.filter((opcion) => opcion.idPadre === aux?.idPadre) 
                    .map((datos)=> {return {label:datos.descripcion, value:datos.id  , title: datos.idPadre?.toString()}}); 
                    this.catUsuarios[i].direccionDepartamentoDescripcion    =  aux?.descripcion;
                    this.catUsuarios[i].idDireccionDepartamento             =  aux?.id ; 
                
                    //if ("fecha_cambio" in jsonObject) this.catUsuarios[i].fechaCambio = jsonObject.fecha_cambio;   
                }   
            } 

        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por getAllCatUsuarios");
        }
    }
 
    // prettier-ignore
    async updateCatUsuarios(catUsuarios: CatUsuarios) {
        try {
            this.fechaActual = new Date();
            catUsuarios.fechaBaja = this.fechaActual;

            //agregamos la info de departamento en el json
            var auxJson = JSON.stringify({
                direccionDepartamentoDescripcion:    catUsuarios.direccionDepartamentoDescripcion,
                idDireccionDepartamento:             catUsuarios.idDireccionDepartamento
            });
            catUsuarios.datosadicionales = auxJson;
            


            const datoRetorno = await this.catUsuariosService
                .update(catUsuarios)
                .toPromise();
        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por updateCatUsuarios");
        }
    }

    // prettier-ignore
    async deleteCatUsuarios(catUsuarios: CatUsuarios) {
        try {
            const datoRetorno = await this.catUsuariosService
                .delete(catUsuarios.id)
                .toPromise();
            this.getAllCatUsuarios();
        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por deleteCatUsuarios");
        }
    }

    // prettier-ignore
    async getAllCatEstatus() {
        try {
            this.progressBar = true;
            const datoRetorno = await this.catEstatusService.getAll().toPromise();
            // this.catEstatus = datoRetorno.map((datos) => {
            //Se crea una constante con los datos de la lista
            const datosLista = datoRetorno.map((datos) => {
                return { label: datos.descripcion, value: datos.id };
            });

            // Se obtienen solo ciertos elementos
            const opcionesLista = 
            [
                { label: "ACTIVO", value: datosLista.filter(x => x.label == 'VIGENTE')[0].value },
                { label: "BAJA", value: datosLista.filter(x => x.label == 'CANCELADO')[0].value },
                                        datosLista.filter(x => x.label == 'BLOQEADO POR DEMASIADOS INTENTOS')[0]
            ];
              
              const defaultValue = { label: "Todos", value: null };
              
              this.catEstatus = [defaultValue, ...opcionesLista];

        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por getCatEstatus");
            this.progressBar = false;
        }
    }

    // prettier-ignore
    async getAllCatDirecciones() {
        try {
            this.progressBar = true;
            const datoRetorno = await this.catDireccionesService.getAll().toPromise();
            this.getAreasGlobal = datoRetorno;
           /* this.catDirecciones = datoRetorno.map((datos) => {
                return { label: datos.descripcion, value: datos.id };
            });*/

            this.catDirecciones = datoRetorno.filter((datos) => [null].includes(datos.idPadre))
            .map((datos)=> {return {label:datos.descripcion, value:datos.id, title: datos.idPadre?.toString()}})

            this.catDirecciones.unshift({ label: "Todos", value: null });
        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por getCatDirecciones");
            this.progressBar = false;
        }
    }

    // prettier-ignore
    async getAllCatDepartamentos() {
        try {
            this.progressBar = true;
            const datoRetorno = await this.catDepartamentosService.getAll().toPromise();
            this.catDepartamentos = datoRetorno.map((datos) => {
                return { label: datos.descripcion, value: datos.id };
            });
            this.catDepartamentos.unshift({ label: "Todos", value: null });
        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por getCatDepartamentos");
            this.progressBar = false;
        }
    }

    // prettier-ignore
    async getAllCatCargos() {
        try {
            this.progressBar = true;
            const datoRetorno = await this.catCargosService.getAll().toPromise();
            this.catCargos = datoRetorno.map((datos) => {
                return { label: datos.descripcion, value: datos.id };
            });
            this.catCargos.unshift({ label: "Todos", value: null });
        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por getCatCargos");
            this.progressBar = false;
        }
    }

    // prettier-ignore
    async getAllCatSucursales() {
        try {
            this.progressBar = true;
            const datoRetorno = await this.catSucursalesService.getAll().toPromise();
            this.catSucursales = datoRetorno.map((datos) => {
                return { label: datos.descripcion, value: datos.id };
            });
            this.catSucursales.unshift({ label: "Todos", value: null });
        } catch (e) {
             this.muestraMensaje.error(e.message, "top", "center"); 
            
        } finally {
            console.log("Paso por getCatSucursales");
            this.progressBar = false;
        }
    }
    async limpiar() {

           this.filterInputNombreU.nativeElement.value = null;
            this.filterInputNombre.nativeElement.value = null;
            this.filterInput1Apellido.nativeElement.value = null;
            this.filterInput2Apellido.nativeElement.value = null;
            this.filterInputTelfono.nativeElement.value = null;
            this.filterInputCorreo.nativeElement.value = null;
            this.filterInputAlta.nativeElement.value = null;


       this.catUsuarios = [];
       
      }
      async clearPassword(event){
        if (event!=null){
            event.contrasenia = null;
        }
      }

      async onIdEstatus(renglon, event)
      { 
      }
      

       isValidEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    
}